import { configureStore } from '@reduxjs/toolkit';
import cycleSliceReducer from './redux/HomePage/cyclesByBuSlice';
import calendarSliceReducer from './redux/Calendar/calendarSlice';
import feedbackCollationSliceReducer from './redux/FeedbackCollation/feedbackCollationSlice';
import generalSliceReducer from './redux/General/generalSlice';
import decisionMakingCentralReducer from './redux/DecisionCentral/decisionCentralRulesSlice';
import portfolioMasterReducer from './redux/PortfolioMaster/portfolioMasterSlice';

const store = configureStore({
  reducer: {
    cycle: cycleSliceReducer,
    calendar: calendarSliceReducer,
    feedbackCollation: feedbackCollationSliceReducer,
    decisionMakingCentralRules: decisionMakingCentralReducer,
    general: generalSliceReducer,
    portfolioMaster: portfolioMasterReducer
  }
});

export default store;
